import { styles } from "../../../utils/styles/products-insurance-styles";
import { colors } from "../../../utils/const";
import { useI18n } from "@/i18n/I18nProvider";
import { useFormik } from "formik";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { dot } from "../../../components/dotlistStyle";
import { useSelector } from "react-redux";
import dynamic from "next/dynamic";
import Image from "next/image";
import { getProductsText } from "../../../../locales/products";

const PageHead = dynamic(() => import("@/components/PageHead"));

const Title = dynamic(
  () => import("../../../components/mini-components/Title.jsx"),
);
const Steps = dynamic(
  () => import("../../../components/steps-brokerage/stepsComp"),
);
const PageCover = dynamic(() => import("@/components/PageCover"));

export default function Index() {
  const mainTab = useSelector((state) => state.mainTab.mainTab);

  const { t, locale } = useI18n();
  const products = getProductsText(locale);

  const isCompanies = mainTab === "شركات";
  const description = isCompanies
    ? products.insurance_page.cover.description_indiv
    : products.insurance_page.cover.description_indiv;

  const onSubmit = async (values, actions) => {
    await new Promise((resolve) => setTimeout(resolve, 5000));
    actions.resetForm();
  };
  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      email: "",
      phoneNumber: "",
      governorate: "",
      area: "",
      username: "",
      lastname: "",
      car_type: "",
      car_price: "",
    },
    onSubmit,
  });
  return (
    <>
      <PageHead
        title={t.pages_main_tags.products.insurance.title}
        description={t.pages_main_tags.products.insurance.meta_desc}
      />
      <Box sx={styles.container}>

        <PageCover
          color={products.insurance_page.cover.color}
          img={products.insurance_page.cover.img}
          title1={products.insurance_page.cover.title1}
          title2={products.insurance_page.cover.title2}
          description={description}
          formType="b"
          product="brokerage"
          source={40}
            flipImg={false}

        />
        {!isCompanies && (
          <Box
            className="horizontal-safe-padding vertical-safe-padding"
            sx={{ bgcolor: colors.white }}
          >
            <Box
              sx={{
                fontSize: "30px",
                color: colors.blue,
                mb: 4,
                fontWeight: "700",
              }}
            >
              {products.insurance_page.subTitle}
            </Box>

            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                justifyContent: { xs: "space-between" },
              }}
            >
              <Grid container spacing={2}>
                {products.insurance_page.section_a.map((item, index) => (
                  <Grid item xs={12} sm={6} lg={3} key={index}>
                    <Image
                      quality={100}
                      src={item.img}
                      width={80}
                      height={80}
                      alt="insurance"
                    />

                    <Box
                      sx={{
                        position: "relative",
                        zIndex: 1,
                      }}
                    >
                      <Box
                        sx={{
                          content: '""',
                          position: "absolute",
                          inset: 0,
                          backgroundColor: "rgba(0, 0, 0, 0.0)",
                          zIndex: -1,
                        }}
                      />
                      <Box
                        sx={{
                          pb: 2,
                          color: colors.orange,
                          fontSize: "30px",
                          fontWeight: "bold",
                        }}
                      >
                        {item.title}
                      </Box>
                    </Box>

                    <Box
                      component="ul"
                      sx={{
                        px: "0",
                        color: colors.navy_blue,
                        fontSize: "20px",
                        ...dot.list,
                        px: 2,
                      }}
                    >
                      {item.points.map((point, pointIndex) => (
                        <li key={pointIndex}>{point}</li>
                      ))}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        )}
        <Steps />
        {isCompanies && (
          <Box
            className="horizontal-safe-margin"
            sx={{
              py: "30px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Title h2="h2" title={t.insurance_companies_title}></Title>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                mt: 2,
              }}
            >
              <Box
                sx={{
                  maxWidth: "900px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: { xs: "initial", md: "space-between" },
                  gap: "5px",
                  flexWrap: "wrap",
                }}
              >
                {t.insuranceFeatures_companies.map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      fontSize: "15px",
                      width: "32%",
                    }}
                  >
                    <img
                      src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/checkbox.png"
                      alt="checkbox"
                      width="16px"
                      loading="lazy"
                    />
                    <Box>{item}</Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
}
